import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useActiveGridStore } from "../store/activeGridStore";
import { LayoutManagerDialog } from "../components/grid/LayoutManagerDialog";
import { breadcrumbFromPath } from "./navConfig";
import { MenuBarModulesMenu } from "./MenuBarModulesMenu";
import { MenuBarQuickActionsMenu } from "./MenuBarQuickActionsMenu";
import { MenuBarToolsMenu } from "./MenuBarToolsMenu";
import { MenuBarUserMenu } from "./MenuBarUserMenu";
import { AlertsMenu } from "./AlertsMenu";

export function MenuBar({
  onOpenCommandPalette,
}: {
  onOpenCommandPalette: () => void;
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { gridApi, activeModule } = useActiveGridStore();
  const [layoutsOpen, setLayoutsOpen] = useState(false);

  const crumbs = breadcrumbFromPath(pathname);

  return (
    <>
      <header className="flex h-[22px] min-h-[22px] shrink-0 items-center gap-3 border-b border-border bg-bg px-2 text-[10px] uppercase tracking-wide">
        <button
          type="button"
          className="font-semibold normal-case text-[var(--fg-primary,#e5e5e5)] hover:text-[var(--color-info,#0ea5e9)]"
          onClick={() => navigate("/")}
        >
          Atlas
        </button>

        <nav className="flex min-w-0 items-center gap-1 text-muted" aria-label="Breadcrumb">
          {crumbs.slice(1).map((c, i) => (
            <span key={`${c.label}-${i}`} className="flex items-center gap-1">
              <span className="text-border">/</span>
              {c.path && i < crumbs.length - 2 ? (
                <Link to={c.path} className="hover:text-[var(--fg-secondary,#d0d0d0)]">
                  {c.label}
                </Link>
              ) : (
                <span className={i === crumbs.length - 2 ? "text-[var(--fg-secondary,#d0d0d0)]" : ""}>{c.label}</span>
              )}
            </span>
          ))}
        </nav>

        <div className="flex items-center gap-2 border-l border-border pl-3">
          <MenuBarModulesMenu />
          <MenuBarQuickActionsMenu
            onOpenCommandPalette={onOpenCommandPalette}
            onOpenLayouts={() => setLayoutsOpen(true)}
          />
          <MenuBarToolsMenu
            onOpenCommandPalette={onOpenCommandPalette}
            onOpenLayouts={() => setLayoutsOpen(true)}
          />
        </div>

        <div className="ml-auto flex items-center gap-2">
          <AlertsMenu />
          <MenuBarUserMenu />
        </div>
      </header>

      <LayoutManagerDialog
        open={layoutsOpen}
        onClose={() => setLayoutsOpen(false)}
        activeModule={activeModule}
        gridApi={gridApi}
      />
    </>
  );
}
